import dayjs from "dayjs";
import {
  FB_CASES_INIT,
  FB_CASE_ACCEPT,
  FB_CASE_START_PROCESS,
  FB_CASE_UPDATE_PROGRESS,
  FB_CASE_RESPOND,
  FB_CASE_REASSIGN,
  FB_CASE_CHANGE_PRIORITY,
} from "./types";

// ─── Sync action creators ──────────────────────────────────────────────────

export const fbCasesInit = (cases) => ({ type: FB_CASES_INIT, payload: cases });

export const fbCaseAccept = (id, officerName) => ({
  type: FB_CASE_ACCEPT,
  payload: { id, officerName, at: new Date().toISOString() },
});

export const fbCaseStartProcess = (id, officerName) => ({
  type: FB_CASE_START_PROCESS,
  payload: { id, officerName, at: new Date().toISOString() },
});

export const fbCaseUpdateProgress = (id, officerName, note) => ({
  type: FB_CASE_UPDATE_PROGRESS,
  payload: { id, officerName, note, at: new Date().toISOString() },
});

export const fbCaseRespond = (id, officerName, responseContent) => ({
  type: FB_CASE_RESPOND,
  payload: { id, officerName, responseContent, at: new Date().toISOString() },
});

/**
 * @param {string} id - case ID
 * @param {{ officerId: string, reason: string }} values
 * @param {{ id, name, role, area }} newOfficer
 * @param {string} currentOfficerName
 */
export const fbCaseReassign = (id, values, newOfficer, currentOfficerName) => ({
  type: FB_CASE_REASSIGN,
  payload: {
    id,
    values,
    newOfficer,
    currentOfficerName,
    at: new Date().toISOString(),
  },
});

/**
 * @param {string} id - case ID
 * @param {{ priority: string, reason: string }} values
 * @param {{ priority: string, prioritySource: object }} currentCase
 * @param {string} officerName
 */
export const fbCaseChangePriority = (id, values, currentCase, officerName) => ({
  type: FB_CASE_CHANGE_PRIORITY,
  payload: {
    id,
    values,
    currentCase,
    officerName,
    at: new Date().toISOString(),
  },
});

// ─── Thunk actions (dispatch + message) ──────────────────────────────────────

export const acceptCase = (c) => (dispatch) => {
  dispatch(fbCaseAccept(c.id, c.assignedOfficer));
};

export const startProcessCase = (c) => (dispatch) => {
  dispatch(fbCaseStartProcess(c.id, c.assignedOfficer));
};

export const updateProgressCase = (id, officerName, note) => (dispatch) => {
  dispatch(fbCaseUpdateProgress(id, officerName, note));
};

export const respondCase = (id, officerName, responseContent) => (dispatch) => {
  dispatch(fbCaseRespond(id, officerName, responseContent));
};

export const reassignCase =
  (id, values, newOfficer, currentOfficerName) => (dispatch) => {
    dispatch(fbCaseReassign(id, values, newOfficer, currentOfficerName));
  };

export const changePriorityCase =
  (id, values, currentCase, officerName) => (dispatch) => {
    dispatch(fbCaseChangePriority(id, values, currentCase, officerName));
  };

// ─── Helpers (shared with reducer & component) ────────────────────────────────

export const NOW = dayjs();

const PRIORITY_MAP = {
  low: { label: "Thấp" },
  medium: { label: "Trung bình" },
  high: { label: "Cao" },
  urgent: { label: "Khẩn cấp" },
};

// helper used inside reducer
export function buildAddTimeline(state, id, event) {
  return state.map((c) =>
    c.id === id ? { ...c, timeline: [...c.timeline, event] } : c,
  );
}

export { PRIORITY_MAP };
